<template>
  <div class="tw-flex tw-justify-center tw-items-center tw-min-h-[320px]">
    <div class="tw-bg-white tw-rounded-xl tw-shadow-md tw-px-8 tw-py-10 tw-max-w-md tw-w-full tw-text-center">
      <div class="tw-flex tw-justify-center tw-mb-4">
        <span class="tw-inline-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-50">
          <span class="tw-h-8 tw-w-8 tw-border-2 tw-border-blue-500 tw-border-t-transparent tw-rounded-full tw-animate-spin" />
        </span>
      </div>
      <p class="tw-text-base tw-font-medium tw-text-slate-800">
        Loading your quote
      </p>
      <p class="tw-mt-2 tw-text-sm tw-text-slate-500">
        This usually only takes a second. Please do not refresh your browser.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingState'
}
</script>
